import { inject, Injectable, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DcProductIdentifierModalComponent } from './dc-product-identifier-modal.component';
import { createModalInjector } from "../../utils/create-modal-injector";
import { ProductIdentifierModalProps } from "./dc-product-identifier-modal-props";

@Injectable({
  providedIn: 'root',
})
export class ProductIdentifierModalService {
  private readonly injector = inject(Injector);

  constructor(private ngbModal: NgbModal) {}

  openDialog(props: ProductIdentifierModalProps): Promise<any> {
    const modalRef = this.ngbModal.open(DcProductIdentifierModalComponent, {
      size: props.size,
      backdrop: props.backdrop,
      centered: true,
      injector: createModalInjector({
        ...props
      }, this.injector)
    });
    return modalRef.result;
  }
}
